import script from "./RoleTimeRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleTimeRow.vue?vue&type=script&setup=true&lang=ts"

import "./RoleTimeRow.vue?vue&type=style&index=0&id=3b562712&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b562712"]])

export default __exports__